import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import "../../styles/css/ElevationForm/elevationForm.css";

class SectionC extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { sectionC, onClickC, validateC } = this.props;
    return (
      <div>
        <div className="form-wrapper-elevation">
          <div>
            <h2>BUILDING ELEVATION INFORMATION (SURVEY REQUIRED)</h2>
            {sectionC.isSubmittedC === false ? (
              <div className="err-msg-content">
                Something went wrong. Please try again.
              </div>
            ) : null}
            <table>
              <tbody>
                <tr>
                  <td colSpan="6">
                    <div className="question-wrapper">
                      <span>C1.</span>
                      <p className="qst-type">
                        {" "}
                        Building elevations are based on:{" "}
                      </p>{" "}
                    </div>
                    <div className="checkbox-wrapper-main-2">
                      <input
                        type="radio"
                        name="building_based"
                        checked={
                          sectionC.building_based === "Construction Drawings"
                        }
                        value="Construction Drawings"
                        onChange={onClickC}
                        className="check-item "
                      />
                      <span className="checkbox-label">
                        {" "}
                        Construction Drawings*
                      </span>
                      <input
                        type="radio"
                        name="building_based"
                        checked={
                          sectionC.building_based ===
                          "Building Under Construction"
                        }
                        value="Building Under Construction"
                        onChange={onClickC}
                        className="check-item "
                      />
                      <span className="checkbox-label">
                        Building Under Construction*
                      </span>
                      <input
                        type="radio"
                        checked={
                          sectionC.building_based === "Finished Construction"
                        }
                        name="building_based"
                        value="Finished Construction"
                        onChange={onClickC}
                        className="check-item "
                      />
                      <span className="checkbox-label">
                        Finished Construction
                      </span>
                    </div>
                    {validateC.message(
                      "building_based",
                      sectionC.building_based,
                      "alpha_num_dash_space",
                      { className: "error-msg-radio" }
                    )}
                    <p className="qst-type">
                      {" "}
                      *A new Elevation Certificate will be required when
                      construction of the building is complete.{" "}
                    </p>{" "}
                  </td>
                </tr>

                <tr>
                  <td colSpan="6">
                    <div className="question-wrapper">
                      <span>C2.</span>
                      <p className="qst-type">
                        {" "}
                        Elevations – Zones A1–A30, AE, AH, A (with BFE), VE,
                        V1–V30, V (with BFE), AR, AR/A, AR/AE, AR/A1–A30, AR/AH,
                        AR/AO. Complete ItemsC2. a–h below according to the
                        building diagram specified in Item A7. In Puerto Rico
                        only, enter meters.
                      </p>
                    </div>
                    <div className="designtion-row-wrapper">
                      <div className="sub-text-label">
                        <span>Benchmark Utilized: </span>
                      </div>
                      <div className="sub-text-label">
                        <input
                          type="text"
                          name="benchmark_utl"
                          value={sectionC.benchmark_utl}
                          onChange={onClickC}
                          className="input-wrapper"
                        />
                        {validateC.message(
                          "benchmark utilized",
                          sectionC.benchmark_utl,
                          "alpha_num_dash_space",
                          { className: "error-msg-text" }
                        )}
                      </div>
                      <div className="sub-text-label">
                        <span>Vertical Datum:</span>
                      </div>
                      <div className="sub-text-label">
                        <input
                          type="text"
                          name="vertical_datum"
                          value={sectionC.vertical_datum}
                          onChange={onClickC}
                          className="input-wrapper"
                        />
                        {validateC.message(
                          "vertical_datum",
                          sectionC.vertical_datum,
                          "alpha_num_dash_space",
                          { className: "error-msg-text" }
                        )}
                      </div>
                    </div>

                    <div className="input-horizontal">
                      <span className="checkbox-label">
                        Indicate elevation datum used for the elevations in
                        items (a) through (h) below.
                      </span>
                    </div>
                    <div className="input-horizontal">
                      <input
                        type="radio"
                        name="elevation_item"
                        value="1929"
                        checked={sectionC.elevation_item === "1929"}
                        onChange={onClickC}
                        className="radio-btn"
                      />
                      <label className="checkbox-label">NGVD 1929</label>
                      <input
                        type="radio"
                        name="elevation_item"
                        value="1988"
                        checked={sectionC.elevation_item === "1988"}
                        onChange={onClickC}
                        className="radio-btn"
                      />
                      <label className="checkbox-label">NAVD 1988</label>
                      <input
                        type="radio"
                        name="elevation_item"
                        checked={sectionC.elevation_item === "other"}
                        value="other"
                        onChange={onClickC}
                        className="radio-btn"
                      />
                      <label className="checkbox-label">Other/Source</label>
                      <input
                        disabled={sectionC.elevation_item !== "other"}
                        type="text"
                        name="elevation_other"
                        value={sectionC.elevation_other}
                        onChange={onClickC}
                        className="form-input-box-small"
                      />
                      {validateC.message(
                        "item value",
                        sectionC.elevation_item,
                        "alpha_num_dash_space",
                        { className: "error-msg-text" }
                      )}
                      <p className="qst-type">
                        {" "}
                        *A new Elevation Certificate will be required when
                        construction of the building is complete.{" "}
                      </p>{" "}
                    </div>

                    <div className="input-horizontal">
                      <span className="checkbox-label">
                        Datum used for building elevations must be the same as
                        that used for the BFE
                      </span>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td colSpan="4"></td>
                  <td>Check the measurement used.</td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <div className="sub-text-question">
                      <span>(a)</span>
                      <label>
                        Top of bottom floor (including basement, crawlspace, or
                        enclosure floor)
                      </label>
                    </div>
                  </td>
                  <td colSpan="1">
                    <input
                      type="text"
                      className="form-input-box"
                      name="top_of_bottom_floor"
                      value={sectionC.top_of_bottom_floor}
                      onChange={onClickC}
                    />
                  </td>
                  <td colSpan="3">
                    <div className="box-wrapper">
                      <input
                        type="radio"
                        name="top_of_bottom_floor_unit"
                        value="feet"
                        checked={sectionC.top_of_bottom_floor_unit === "feet"}
                        onChange={onClickC}
                        className="checkbox-icon-btn"
                      />
                      <span className="checkbox-label">feet</span>
                      <input
                        type="radio"
                        name="top_of_bottom_floor_unit"
                        value="meters"
                        checked={sectionC.top_of_bottom_floor_unit === "meters"}
                        onChange={onClickC}
                        className="checkbox-icon-btn"
                      />
                      <span className="checkbox-label">meters</span>
                    </div>
                  </td>
                </tr>
                {sectionC.answer9 === "no" ? (
                  <tr>
                    <td colSpan="2">
                      <div className="sub-text-question">
                        <span>(b)</span>
                        <label>Top of the next higher floor</label>
                      </div>
                    </td>
                    <td colSpan="1">
                      <input
                        type="text"
                        value={sectionC.top_of_next_floor}
                        className="form-input-box"
                        name="top_of_next_floor"
                        onChange={onClickC}
                      />
                    </td>
                    <td colSpan="3">
                      <div className="box-wrapper">
                        <input
                          disabled
                          type="radio"
                          name="top_of_next_floor_unit"
                          checked={sectionC.top_of_next_floor_unit === "feet"}
                          value="feet"
                          onChange={onClickC}
                          className="checkbox-icon-btn"
                        />
                        <span className="checkbox-label">feet</span>
                        <input
                          disabled
                          type="radio"
                          name="top_of_next_floor_unit"
                          value="meters"
                          checked={sectionC.top_of_next_floor_unit === "meters"}
                          onChange={onClickC}
                          className="checkbox-icon-btn"
                        />
                        <span className="checkbox-label">meters</span>
                      </div>
                    </td>
                  </tr>
                ) : sectionC.answer9 === "yes" || sectionC.answer9 === "" ? (
                  <tr>
                    <td colSpan="2">
                      <div className="sub-text-question">
                        <span>(b)</span>
                        <label>Top of the next higher floor</label>
                      </div>
                    </td>
                    <td colSpan="1">
                      <input
                        type="text"
                        value={sectionC.top_of_next_floor}
                        className="form-input-box"
                        name="top_of_next_floor"
                        onChange={onClickC}
                      />
                    </td>
                    <td colSpan="3">
                      <div className="box-wrapper">
                        <input
                          type="radio"
                          name="top_of_next_floor_unit"
                          value="feet"
                          checked={sectionC.top_of_next_floor_unit === "feet"}
                          onChange={onClickC}
                          className="checkbox-icon-btn"
                        />
                        <span className="checkbox-label">feet</span>
                        <input
                          type="radio"
                          name="top_of_next_floor_unit"
                          checked={sectionC.top_of_next_floor_unit === "meters"}
                          value="meters"
                          onChange={onClickC}
                          className="checkbox-icon-btn"
                        />
                        <span className="checkbox-label">meters</span>
                      </div>
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan="2">
                      <div className="sub-text-question">
                        <span>(b)</span>
                        <label>Top of the next higher floor</label>
                      </div>
                    </td>
                    <td colSpan="1">
                      <input
                        type="text"
                        value={sectionC.top_of_next_floor}
                        className="form-input-box"
                        name="top_of_next_floor"
                        onChange={onClickC}
                      />
                    </td>
                    <td colSpan="3">
                      <div className="box-wrapper">
                        <input
                          type="radio"
                          name="top_of_next_floor_unit"
                          value="feet"
                          checked={sectionC.top_of_next_floor_unit === "feet"}
                          onChange={onClickC}
                          className="checkbox-icon-btn"
                        />
                        <span className="checkbox-label">feet</span>
                        <input
                          type="radio"
                          name="top_of_next_floor_unit"
                          checked={sectionC.top_of_next_floor_unit === "meters"}
                          value="meters"
                          onChange={onClickC}
                          className="checkbox-icon-btn"
                        />
                        <span className="checkbox-label">meters</span>
                      </div>
                    </td>
                  </tr>
                )}

                <tr>
                  <td colSpan="2">
                    <div className="sub-text-question">
                      <span>(c) </span>
                      <label>
                        Bottom of the lowest horizontal structural member (V
                        Zones only)
                      </label>
                    </div>
                  </td>
                  <td colSpan="1">
                    <input
                      type="text"
                      className="form-input-box"
                      value={sectionC.bottom_of_lowest_member}
                      name="bottom_of_lowest_member"
                      onChange={onClickC}
                    />{" "}
                  </td>
                  <td colSpan="3">
                    <div className="box-wrapper">
                      <input
                        type="radio"
                        name="bottom_of_lowest_member_unit"
                        value="feet"
                        checked={
                          sectionC.bottom_of_lowest_member_unit === "feet"
                        }
                        onChange={onClickC}
                        className="checkbox-icon-btn"
                      />
                      <span className="checkbox-label">feet</span>
                      <input
                        type="radio"
                        name="bottom_of_lowest_member_unit"
                        value="meters"
                        checked={
                          sectionC.bottom_of_lowest_member_unit === "meters"
                        }
                        onChange={onClickC}
                        className="checkbox-icon-btn"
                      />
                      <span className="checkbox-label">meters</span>
                    </div>
                  </td>
                </tr>
                {sectionC.answer1 === "no" ? (
                  <tr>
                    <td colSpan="2">
                      <div className="sub-text-question">
                        <span>(d)</span>
                        <label>Attached garage (top of slab)</label>
                      </div>
                    </td>
                    <td colSpan="1">
                      <input
                        type="text"
                        className="form-input-box"
                        name="attached_garage_top_slab"
                        value={sectionC.attached_garage_top_slab}
                        onChange={onClickC}
                      />
                    </td>
                    <td colSpan="3">
                      <div className="box-wrapper">
                        <input
                          disabled
                          type="radio"
                          name="attached_garage_top_slab_unit"
                          onChange={onClickC}
                          checked={
                            sectionC.attached_garage_top_slab_unit === "feet"
                          }
                          value="feet"
                          className="checkbox-icon-btn"
                        />
                        <span className="checkbox-label">feet</span>
                        <input
                          disabled
                          type="radio"
                          name="attached_garage_top_slab_unit"
                          value="meters"
                          checked={
                            sectionC.attached_garage_top_slab_unit === "meters"
                          }
                          onChange={onClickC}
                          className="checkbox-icon-btn"
                        />
                        <span className="checkbox-label">meters</span>
                      </div>
                    </td>
                  </tr>
                ) : sectionC.answer1 === "yes" || sectionC.answer1 === "" ? (
                  <tr>
                    <td colSpan="2">
                      <div className="sub-text-question">
                        <span>(d)</span>
                        <label>Attached garage (top of slab)</label>
                      </div>
                    </td>
                    <td colSpan="1">
                      <input
                        type="text"
                        name="attached_garage_top_slab"
                        value={sectionC.attached_garage_top_slab}
                        onChange={onClickC}
                        className="form-input-box"
                      />
                    </td>
                    <td colSpan="3">
                      <div className="box-wrapper">
                        <input
                          type="radio"
                          name="attached_garage_top_slab_unit"
                          checked={
                            sectionC.attached_garage_top_slab_unit === "feet"
                          }
                          value="feet"
                          onChange={onClickC}
                          className="checkbox-icon-btn"
                        />
                        <span className="checkbox-label">feet</span>
                        <input
                          type="radio"
                          name="attached_garage_top_slab_unit"
                          onChange={onClickC}
                          checked={
                            sectionC.attached_garage_top_slab_unit === "meters"
                          }
                          value="meters"
                          className="checkbox-icon-btn"
                        />
                        <span className="checkbox-label">meters</span>
                      </div>
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan="2">
                      <div className="sub-text-question">
                        <span>(d)</span>
                        <label>Attached garage (top of slab)</label>
                      </div>
                    </td>
                    <td colSpan="1">
                      <input
                        type="text"
                        name="attached_garage_top_slab"
                        value={sectionC.attached_garage_top_slab}
                        onChange={onClickC}
                        className="form-input-box"
                      />
                    </td>
                    <td colSpan="3">
                      <div className="box-wrapper">
                        <input
                          type="radio"
                          name="attached_garage_top_slab_unit"
                          checked={
                            sectionC.attached_garage_top_slab_unit === "feet"
                          }
                          value="feet"
                          onChange={onClickC}
                          className="checkbox-icon-btn"
                        />
                        <span className="checkbox-label">feet</span>
                        <input
                          type="radio"
                          name="attached_garage_top_slab_unit"
                          onChange={onClickC}
                          checked={
                            sectionC.attached_garage_top_slab_unit === "meters"
                          }
                          value="meters"
                          className="checkbox-icon-btn"
                        />
                        <span className="checkbox-label">meters</span>
                      </div>
                    </td>
                  </tr>
                )}

                <tr>
                  <td colSpan="2">
                    <div className="sub-text-question">
                      <span>(e)</span>
                      <label>
                        Lowest elevation of machinery or equipment servicing the
                        building (Describe type of equipment and location in
                        Comments)
                      </label>
                    </div>
                  </td>
                  <td colSpan="1">
                    <input
                      type="text"
                      name="lowest_elevation"
                      value={sectionC.lowest_elevation}
                      onChange={onClickC}
                      className="form-input-box"
                    />
                  </td>
                  <td colSpan="3">
                    <div className="box-wrapper">
                      <input
                        type="radio"
                        checked={sectionC.lowest_elevation_unit === "feet"}
                        name="lowest_elevation_unit"
                        onChange={onClickC}
                        value="feet"
                        className="checkbox-icon-btn"
                      />
                      <span className="checkbox-label">feet</span>
                      <input
                        type="radio"
                        checked={sectionC.lowest_elevation_unit === "meters"}
                        name="lowest_elevation_unit"
                        onChange={onClickC}
                        value="meters"
                        className="checkbox-icon-btn"
                      />
                      <span className="checkbox-label">meters</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <div className="sub-text-question">
                      <span>(f)</span>
                      <label>
                        Lowest adjacent (finished) grade next to building (LAG)
                      </label>
                    </div>
                  </td>
                  <td colSpan="1">
                    <input
                      name="lowest_adjacent"
                      value={sectionC.lowest_adjacent}
                      onChange={onClickC}
                      type="text"
                      className="form-input-box"
                    />
                  </td>
                  <td colSpan="3">
                    <div className="box-wrapper">
                      <input
                        type="radio"
                        checked={sectionC.lowest_adjacent_unit === "feet"}
                        name="lowest_adjacent_unit"
                        value="feet"
                        onChange={onClickC}
                        className="checkbox-icon-btn"
                      />

                      <span className="checkbox-label">feet</span>
                      <input
                        checked={sectionC.lowest_adjacent_unit === "meters"}
                        type="radio"
                        name="lowest_adjacent_unit"
                        value="meters"
                        onChange={onClickC}
                        className="checkbox-icon-btn"
                      />
                      <span className="checkbox-label">meters</span>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <div className="sub-text-question">
                      <span> (g) </span>
                      <label>
                        Highest adjacent (finished) grade next to building (HAG)
                      </label>
                    </div>
                  </td>
                  <td colSpan="1">
                    <input
                      type="text"
                      name="highest_adjacent"
                      value={sectionC.highest_adjacent}
                      className="form-input-box"
                      onChange={onClickC}
                    />
                  </td>
                  <td colSpan="3">
                    <div className="box-wrapper">
                      <input
                        type="radio"
                        checked={sectionC.highest_adjacent_unit === "feet"}
                        name="highest_adjacent_unit"
                        value="feet"
                        onChange={onClickC}
                        className="checkbox-icon-btn"
                      />
                      <span className="checkbox-label">feet</span>
                      <input
                        type="radio"
                        checked={sectionC.highest_adjacent_unit === "meters"}
                        name="highest_adjacent_unit"
                        value="meters"
                        onChange={onClickC}
                        className="checkbox-icon-btn"
                      />
                      <span className="checkbox-label">meters</span>
                    </div>{" "}
                  </td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <div className="sub-text-question">
                      <span> (h) </span>
                      <label>
                        Lowest adjacent grade at lowest elevation of deck or
                        stairs, including structural support
                      </label>
                    </div>
                  </td>
                  <td colSpan="1">
                    <input
                      type="text"
                      name="lowest_adjacent_grade"
                      value={sectionC.lowest_adjacent_grade}
                      onChange={onClickC}
                      className="form-input-box"
                    />
                  </td>
                  <td colSpan="3">
                    <div className="box-wrapper">
                      <input
                        checked={sectionC.lowest_adjacent_grade_unit === "feet"}
                        type="radio"
                        name="lowest_adjacent_grade_unit"
                        onChange={onClickC}
                        value="feet"
                        className="checkbox-icon-btn"
                      />
                      <span className="checkbox-label">feet</span>
                      <input
                        checked={
                          sectionC.lowest_adjacent_grade_unit === "meters"
                        }
                        type="radio"
                        name="lowest_adjacent_grade_unit"
                        onChange={onClickC}
                        value="meters"
                        className="checkbox-icon-btn"
                      />
                      <span className="checkbox-label">meters</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default SectionC;



// WEBPACK FOOTER //
// ./src/pages/ElevationForm/SectionC.js